import React, { useState } from 'react'
import styled from 'styled-components'
import {tabsData} from "../data/TabsData"
import "./Styles/Style.css"
const TabSelector = ({filterItem}) => {
    const [active, setActive] = useState(0);

    return (
        <TabsWrapper>
           <TabsContainer>
      {tabsData.map((item, i) => 
        <TabsBtn className={active === i ? "active" : ""} type="button" key={i} onClick={() => {
            filterItem(item.title)
            // Condition for toggling the lists.
                  // If current list is Selected
                  if (active === i) {
                    // change active to blank
                    setActive();
                  } else {
                    // change active to current index
                    setActive(i);
                  }
            }}>
        {item.title}
          
        </TabsBtn>
      
        
      )}
      
           </TabsContainer>
            
        </TabsWrapper>
    )
}

export default TabSelector

const TabsWrapper = styled.div`
height: 80px;
width: 100vw;
margin-top: -40px;
z-index:2;
position: absolute;

`
const TabsContainer = styled.div`
margin: 0 auto;
height: 80px;
width: 770px;
background-color: #fff;
box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.25);
border-radius: 5px;
display: flex;
align-items: center;
justify-content: center;
@media screen and (max-width: 880px) {
width: 670px;
}
@media screen and (max-width: 720px) {
width: 570px;
}
@media screen and (max-width: 620px) {
width: 500px;
}
@media screen and (max-width: 572px) {
width: 450px;
}
@media screen and (max-width: 500px) {
width: 400px;
height: 60px;
}
@media screen and (max-width: 420px) {
width: 350px;
height: 60px;
}
@media screen and (max-width: 360px) {
width: 320px;
height: 50px;
}
@media screen and (max-width: 320px) {
width: 300px;
height: 40px;
}
@media screen and (max-width: 300px) {
width: 260px;
height: 40px;
}
`
const TabsBtn = styled.button`
margin: 0 12px;
font-size: clamp(0.5rem, 2vw, 1.2rem);
padding: 12px 10px;
border-radius: 5px;
outline: none;
border: none;
background-color: transparent;
cursor: pointer;
&:hover{
    background-color: #4C52EA;
    color: #fff;

}

@media screen and (max-width: 620px) {
    padding: 10px 7px;
&:active, :focus{
        font-size: 1rem;}
}
}
@media screen and (max-width: 572px) {
    padding: 10px 6px;
&:active, :focus{
        font-size: 1rem;}
}
}
@media screen and (max-width: 500px) {
    margin: 0 8px;
    padding: 10px 6px;
&:active, :focus{
        font-size: 1rem;}
}
}
@media screen and (max-width: 420px) {
    margin: 0 8px;
    padding: 10px 6px;
&:active, :focus{
        font-size: 1rem;}
}
}
@media screen and (max-width: 360px) {
    margin: 0 5px;
    padding: 5px 6px;
  &:active, :focus{
        font-size: 0.8rem;}
}
@media screen and (max-width: 320px) {
    margin: 0 5px;
    padding: 5px 5px;
  &:active, :focus{
        font-size: 0.6rem;}
}
@media screen and (max-width: 300px) {
    margin: 0 4px;
    padding: 5px 3px;
  &:active, :focus{
        font-size: 0.6rem;}
}
`